module.exports = __webpack_public_path__ + "static/30-870dc5b7fdde69bb68732728566d0741.jpg";